import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";

import { Select, Button } from "components";
import { NoDataIcon } from "icons";

import {
  FactorsNEffectsActionCreators,
  StressDepartmentListActionCreators,
} from "redux/rootActions";
import { factorsNEffectsDataResponse } from "redux/stressCheck/factorsNEffects/factorsNEffectsStates";
import { departmentListDataResponse } from "redux/stressCheck/departmentList/departmentListStates";

import { WrapperLegendLineChart } from "screens/dashboard/Dashboard.style";
import {
  BoxContentChart,
  WapperSelectTimeForItem,
  RadarChartWrapper,
  Square,
  RadarChartSelectWrapper,
  ChartHeaderGroup,
  RadarChartContainer,
} from "../Stress.style";
import RadarChart from "./RadarChart";

const yearOptions: any = [];
for (let i = 2000; i <= 2030; i++) {
  yearOptions.push({
    key: i,
    value: i,
    // name: i + "年",
    name: i,
  });
}

const monthOptions: any = [];
for (let i = 1; i <= 12; i++) {
  monthOptions.push({
    key: i,
    value: i,
    // name: i + "月",
    name: i,
  });
}

const FactorsAndEffect: React.FC<any> = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "stress-check",
  });
  const { t: t1 } = useTranslation("translation", {
    keyPrefix: "vaccination",
  });
  const { t: t2 } = useTranslation("translation", {
    keyPrefix: "account",
  });
  const dispatch = useDispatch();

  const { handleSubmit, control } = useForm();

  const factorsNEffectsData = useSelector(factorsNEffectsDataResponse);
  const departmentListData = useSelector(departmentListDataResponse);
  const [dataChart, setDataChart] = useState({
    graph1: [],
    graph2: [],
    graph3: [],
  });
  const [departmentListOptions, setDepartmentListOptions] = useState([]);

  useEffect(() => {
    dispatch(StressDepartmentListActionCreators.getDepartmentListAction());
    dispatch(
      FactorsNEffectsActionCreators.getFactorsNEffectsAction({
        month: "",
        year: moment().year().toString(),
        designation: "",
        locale: "vi",
      })
    );
  }, []);

  useEffect(() => {
    if (factorsNEffectsData && Object.keys(factorsNEffectsData).length) {
      const firstGraph = factorsNEffectsData.result.graph1.map((item: any) => {
        return {
          subject: item.name,
          A: item.company_average,
          B: item.danger_zone,
          fullMark: item.max_value,
        };
      });
      const secondGraph = factorsNEffectsData.result.graph2.map((item: any) => {
        return {
          subject: item.name,
          A: item.company_average,
          B: item.danger_zone,
          fullMark: item.max_value,
        };
      });
      const thirdGraph = factorsNEffectsData.result.graph3.map((item: any) => {
        return {
          subject: item.name,
          A: item.company_average,
          B: item.danger_zone,
          fullMark: item.max_value,
        };
      });
      setDataChart({
        graph1: firstGraph,
        graph2: secondGraph,
        graph3: thirdGraph,
      });
      dispatch(FactorsNEffectsActionCreators.handleResetAction());
    }
  }, [factorsNEffectsData]);

  useEffect(() => {
    if (departmentListData && Object.keys(departmentListData).length) {
      setDepartmentListOptions(
        departmentListData.result.map((item: any) => {
          return {
            key: item.id,
            value: item.id,
            name: item.name,
          };
        })
      );
    }
  }, [departmentListData]);

  const onSubmit = (data: any) => {
    dispatch(
      FactorsNEffectsActionCreators.getFactorsNEffectsAction({
        month: data.month || "",
        year: data.year || "",
        designation: data.departmentList || "",
      })
    );
  };

  return (
    <>
      <RadarChartContainer>
        <ChartHeaderGroup>
          <div
            style={{
              fontWeight: 700,
              fontSize: 16,
              lineHeight: "16px",
            }}
          >
            {t("factors-and-effects")}
          </div>
          <RadarChartSelectWrapper onSubmit={handleSubmit(onSubmit)}>
            <Controller
              control={control}
              name="departmentList"
              render={({ field: { onChange } }) => (
                <Select
                  options={departmentListOptions}
                  width={"76px"}
                  placeholder={t1("all")}
                  height="30px"
                  //   defaultValue={item.end_hour}
                  onChange={onChange}
                />
              )}
            />

            <WapperSelectTimeForItem>
              <div className="bor-div-time">
                <div className="dright">
                  <Controller
                    control={control}
                    name="year"
                    render={({ field: { onChange } }) => (
                      <Select
                        options={yearOptions}
                        width={"100px"}
                        // placeholder="2022年"
                        placeholder="2025"
                        height="30px"
                        //   defaultValue={item.end_hour}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Controller
                    control={control}
                    name="month"
                    render={({ field: { onChange } }) => (
                      <Select
                        options={monthOptions}
                        width={"82px"}
                        // placeholder="01月"
                        placeholder="01"
                        height="30px"
                        marginForm="0px 0px 0px 8px"
                        onChange={onChange}
                        //   defaultValue={item.end_minute}
                      />
                    )}
                  />
                </div>
              </div>
            </WapperSelectTimeForItem>
            <Button
              color="#FFFFFF"
              fontSize={16}
              fontWeight={700}
              lineHeight="23px"
              background="#2AC769"
              padding="3px 12px"
              name={t2("update")}
              bdr="6px"
              border="none"
              // onClick={handleSearchGraph2}
            />
          </RadarChartSelectWrapper>
        </ChartHeaderGroup>

        <BoxContentChart>
          {dataChart.graph1.length ? (
            <RadarChartWrapper>
              <p>{t("causative-factors")}</p>
              <RadarChart data={dataChart.graph1} idx={9} />
            </RadarChartWrapper>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 17,
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  fontSize: 12,
                  lineHeight: "12px",
                  marginBottom: 8,
                }}
              >
                {/* ストレスチェック（59） */}
                {t("stress-check-59")}
              </div>
              <NoDataIcon width={155} height={155} />
            </div>
          )}
          {dataChart.graph2.length ? (
            <RadarChartWrapper>
              <p>{t("influencing-factors")}</p>
              <RadarChart data={dataChart.graph2} idx={4} />
            </RadarChartWrapper>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 17,
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  fontSize: 12,
                  lineHeight: "12px",
                  marginBottom: 8,
                }}
              >
                {t("stress-check-59")}
              </div>
              <NoDataIcon width={155} height={155} />
            </div>
          )}
          {dataChart.graph3.length ? (
            <RadarChartWrapper>
              <p>{t("mind-body-reaction")}</p>
              <RadarChart data={dataChart.graph3} idx={6} />
            </RadarChartWrapper>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 17,
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  fontSize: 12,
                  lineHeight: "12px",
                  marginBottom: 8,
                }}
              >
                {t("stress-check-59")}
              </div>
              <NoDataIcon width={155} height={155} />
            </div>
          )}
        </BoxContentChart>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 16,
          }}
        >
          <WrapperLegendLineChart>
            <Square
              style={{ background: "#2F8CAE", marginTop: 0, opacity: 0.25 }}
            />
            <p>{t("last-month")}</p>
          </WrapperLegendLineChart>
          <WrapperLegendLineChart>
            <Square
              style={{ background: "#2F8CAE", marginTop: 0, opacity: 0.75 }}
            />
            <p>{t("this-month")}</p>
          </WrapperLegendLineChart>
        </div>
      </RadarChartContainer>
    </>
  );
};

export default FactorsAndEffect;
